import MenuSpy from "menuspy";
import _debounce from "lodash/debounce";
import _some from "lodash/some";
import _trimEnd from "lodash/trimEnd";
import _last from "lodash/last";

export default class ProgressSidebar {
    mount({ progressSidebarSelector, barThumbHeight, barTopPos }) {
        if ($(progressSidebarSelector).length) {
            function getCurrentStepEl() {
                const url = window.location.href;
                const $sidebarSteps = $(".progress-sidebar-step .step-link");
                const getStep = url => _last(_trimEnd(url, "/").split());

                return $(
                    $sidebarSteps.toArray().find($step => {
                        const stepUrl = $($step).attr("href");
                        return getStep(url) === getStep(stepUrl);
                    })
                );
            }

            // build substep menu within current step
            const $currentStep = getCurrentStepEl();
            const $anchors = $(
                ".guide-step-container .content h1[id], .guide-step-container .content h2[id]"
            );
            const $substepsEl = $('<ul class="substeps"></ul>');
            const $substeps = $anchors
                .toArray()
                .map(anchor =>
                    $(
                        `<li class="substep"><a class="anchor-link" href="#${$(
                            anchor
                        ).attr("id")}">${$(anchor).text()}</a></li>`
                    )
                );

            $substepsEl.append($substeps);
            $substepsEl.insertAfter($currentStep);
            $currentStep.addClass("active");

            // build vertical bar that indicates which substep is currently active in the viewport
            const $barWrapper = $('<div class="bar-wrapper"></div>');
            const $barTrack = $('<div class="bar-track"></div>');
            const $barThumb = $('<div class="bar-thumb"></div>');

            $barWrapper.append($barTrack);
            $barWrapper.append($barThumb);
            $substepsEl.append($barWrapper);

            // https://github.com/lcdsantos/menuspy
            new MenuSpy(progressSidebarSelector, {
                activeClass: "active",
                enableLocationHash: false,
                callback: currentItem => {
                    // This slides the progress bar thumb to the current anchor
                    // link. The thumb is initialized exactly outside the step
                    // element from the top out of view, It calculates the
                    // anchor link's vertical offset from it's parent, then
                    // moves the bar thumb that amount from it's initial
                    // position + it's own height and some buffer barTopPos
                    const $el = currentItem.elm;
                    const offsetFromSubstepsEl =
                        $($el).position().top +
                        $($el)
                            .parent()
                            .position().top +
                        barThumbHeight -
                        barTopPos;

                    $barThumb.css({
                        transform: `translateY(${offsetFromSubstepsEl}px)`,
                    });
                },
            });

            // hide bar thumb when no substep is active
            $(window).scroll(
                _debounce(() => {
                    const activeSubstepExists = _some($substeps, $substep =>
                        $substep.hasClass("active")
                    );

                    if (!activeSubstepExists) {
                        $barThumb.css({
                            transform: `translateY(-${barThumbHeight}px)`,
                        });
                    }
                }, 300)
            );

            function setProgressBarHeight() {
                const substepsHeight = $substepsEl.height();
                $barWrapper.height(substepsHeight);
            }

            setProgressBarHeight();

            // When progress sidebar is display: none on smaller viewports,
            // the vertical bar is not visible because it has 0 height. This fixes that issue.
            $(window).resize(_debounce(setProgressBarHeight, 300));
        }
    }
}



// WEBPACK FOOTER //
// ./themes/docs/static/js/progress-sidebar.js